<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-cascader :props="props" v-model="area_store" placeholder="选择或搜索门店" @visible-change="visibleChange"
          @change="clearRoom" style="margin-right: 10px;" collapse-tags clearable filterable></el-cascader>
        <el-input v-model="query.real_name" placeholder="客户称呼" class="handle-input mr10"></el-input>
        <el-input v-model="query.nickname" placeholder="昵称" class="handle-input mr10"></el-input>
        <el-input v-model="query.phone" placeholder="客户手机号" class="handle-input mr10"></el-input>

        <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
          <el-option key="1" label="有效" value="1"></el-option>
          <el-option key="2" label="无效" value="0"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch(null, 0)" class="mr10">搜索</el-button>
        <el-button type="primary"
          :icon="yeIcon != null ? (yeIcon === true ? 'el-icon-sort-up' : 'el-icon-sort-down') : 'el-icon-sort'"
          @click="handleSearch(1, 2)" class="mr10">余额</el-button>
        <el-button type="primary"
          :icon="xfIcon != null ? (xfIcon === true ? 'el-icon-sort-up' : 'el-icon-sort-down') : 'el-icon-sort'"
          @click="handleSearch(3, 1)" class="mr10">累计消费</el-button>
        <vue3-json-excel class="export-excel-wrapper" :json-data="json_user_data" :fields="json_user_fields"
          :before-generate="handleUserDownload" name="会员.xls">
          <el-button icon="el-icon-download">导出</el-button>
        </vue3-json-excel>
      </div>
      <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
        <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
        <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
        <el-table-column prop="real_name" label="客户称呼" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column label="头像" prop="avatar" align="center" width="100">
          <template #default="scope">
            <el-image v-if="scope.row.avatar" class="table-td-thumb" :src="scope.row.avatar"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="性别" align="center" width="100">
          <template #default="scope">
            {{ sexMap.get(scope.row.sex) }}
          </template>
        </el-table-column>
        <el-table-column label="余额" align="right">
          <template #default="scope">
            <el-button type="text" :style="'color:#409EFF'" @click="getBalances(scope.row.id, scope.row)">
              {{ (scope.row.balance_total / 100).toFixed(2) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="积分" align="center">
          <template #default="scope">
            <el-button type="text" :style="'color:#409EFF'" @click="getIntegrals(scope.row.id, scope.row)">
              {{ scope.row.score_total }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="累计消费" align="center">
          <template #default="scope">
            {{ (scope.row.consume_total / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="用户标签" width="120" align="center" show-overflow-tooltip>
          <template #default="scope">
            <el-tag v-for="item in scope.row.activityRules" :key="item.ID" type="success" size="mini">{{ item.name
              }}</el-tag>
            <el-tag v-for="item in scope.row.spendAmountRules" :key="item.ID" size="mini">{{ item.name }}</el-tag>
            <el-tag v-for="item in scope.row.registrationTimeRules" :key="item.ID" type="danger" size="mini">{{
              item.name }}</el-tag>
            <el-tag v-for="item in scope.row.customRules" :key="item.ID" size="mini">{{ item.name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否有效" width="100" align="center">
          <template #default="scope">
            <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
              @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
              {{ scope.row.is_validate ? "有效" : "无效" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="c_at" :formatter="dateFormat" align="center" label="添加时间"
          width="200px;"></el-table-column>
        <el-table-column prop="c_at" :formatter="dateFormat" align="center" label="操作" width="200px;">
          <template #default="scope">
            <el-button type="text" @click="getCoupons(scope.row.id, scope.row)">卡券账户</el-button>
            <el-button type="text" @click="giftCoupon(scope.row.id)">赠送卡券</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.page"
          :page-sizes="[10, 20, 50, 100, 200, 500, 99999]" :page-size="query.page_size"
          layout="total,sizes, prev, pager, next" :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 积分记录  -->
    <el-dialog :title="userName + ' 的积分记录'" width="50%" v-model="integralsVisible">
      <vue3-json-excel class="export-excel-wrapper" :json-data="json_integrals_data" :fields="json_integrals_fields"
        :before-generate="handleIntegralsDownload" name="积分记录.xls">
        <el-button icon="el-icon-download" style="margin-bottom: 10px;">导出</el-button>
      </vue3-json-excel>
      <el-table :data="integrals">
        <el-table-column property="score" label="积分">
          <template #default="scope">
            <span>{{ (scope.row.type == 2) ? '-' : '+' }}</span>
            {{ scope.row.score }}
          </template>
        </el-table-column>
        <el-table-column property="type" label="类型" width="150">
          <template #default="scope">
            {{ integralsMap.get(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column property="memo" label="备注"></el-table-column>
        <el-table-column property="c_at_date" label="时间" width="200"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleintegralsSizeChange" @current-change="handleintegralsChange"
          :current-page="integralsquery.page" :page-sizes="[10, 20, 50, 100, 200]" :page-size="integralsquery.page_size"
          layout="total,sizes, prev, pager, next" :total="integralsTotal">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 余额记录  -->
    <el-dialog :title="userName + ' 的余额记录'" width="50%" v-model="balancesVisible">
      <el-tabs v-model="activeDName" type="card" @tab-click="handleBalanceClick">
        <el-tab-pane label="余额记录" name="first">
          <vue3-json-excel class="export-excel-wrapper" :json-data="json_balances_data" :fields="json_balances_fields"
            :before-generate="handleBalancesDownload" name="余额记录.xls">
            <el-button icon="el-icon-download" style="margin-bottom: 10px;">导出</el-button>
          </vue3-json-excel>
          <el-table :data="balances">
            <el-table-column property="money" label="余额" align="right" width="120">
              <template #default="scope">
                <span>{{ (scope.row.type == 2) ? '-' : '+' }}</span>
                {{ (scope.row.money / 100).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column property="type" label="类型" align="center">
              <template #default="scope">
                {{ balancesMap.get(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column property="type" label="赠送" width="100">
              <template #default="scope">
                <span v-if="scope.row.type == 1">{{ ((scope.row.deposit - scope.row.charge) / 100).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column property="store_id" label="门店/平台" width="200">
              <template #default="scope">
                {{ scope.row.store_name }}
              </template>
            </el-table-column>
            <el-table-column property="store_id" label="使用门店" width="200">
              <template #default="scope">
                {{ scope.row.use_store_name }}
              </template>
            </el-table-column>
            <el-table-column property="memo" label="备注"></el-table-column>
            <el-table-column property="c_at_date" label="时间" width="200"></el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handlebalancesSizeChange" @current-change="handlebalancesChange"
              :current-page="balancesquery.page" :page-sizes="[10, 20, 50, 100, 200, 500, 99999]"
              :page-size="balancesquery.page_size" layout="total,sizes, prev, pager, next" :total="balancesTotal">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="余额详情" name="second">
          <el-table :data="storeList">
            <el-table-column prop="store_id" label="门店ID" align="center" width="80">
            </el-table-column>
            <el-table-column prop="store_name" align="center" label="门店名">
            </el-table-column>
            <el-table-column prop="store_name" label="余额" align="right" width="180">
              <template #default="scope">
                {{ (scope.row.total / 100).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="350" align="center">
              <template #default="scope">
                <el-button type="text" @click="showRecord(scope.row.store_id)" icon="el-icon-time">
                  查看余额记录
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleStoreSizeChange" @current-change="handleStoreChange"
              :current-page="storequery.page" :page-sizes="[10, 20, 50, 100, 200, 500, 99999]"
              :page-size="storequery.page_size" layout="total,sizes, prev, pager, next" :total="storePageTotal">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog :title="userName + ' 的余额记录'" width="50%" v-model="storeBalancesVisible">
      <el-table :data="storeRecord">
        <el-table-column property="money" label="余额" align="right" width="120">
          <template #default="scope">
            <span>{{ (scope.row.type == 2) ? '-' : '+' }}</span>
            {{ (scope.row.money / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column property="type" label="类型" align="center">
          <template #default="scope">
            {{ balancesMap.get(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column property="type" label="赠送" width="100">
          <template #default="scope">
            <span v-if="scope.row.type == 1">{{ ((scope.row.deposit - scope.row.charge) / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="memo" label="备注"></el-table-column>
        <el-table-column property="c_at_date" label="时间" width="200"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleRecordSizeChange" @current-change="handleRecordChange"
          :current-page="recordquery.page" :page-sizes="[10, 20, 50, 100, 200, 500, 9999999]"
          :page-size="recordquery.page_size" layout="total,sizes, prev, pager, next" :total="recordPageTotal">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 卡券列表 -->
    <el-dialog :title="userName + ' 的卡券'" width="80%" v-model="CouponVisible">
      <el-table :data="CouponRecord">
        <el-table-column property="name" label="卡券名称" show-overflow-tooltip></el-table-column>
        <el-table-column property="duration" width="80" label="时长"></el-table-column>
        <el-table-column property="price" label="价格"></el-table-column>
        <el-table-column property="status" label="使用状态" align="center" width="80" v-if="couponOperateType == 1">
          <template #default="scope">
            <span>{{ statusMap.get(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="status" label="启用状态" align="center" width="80" v-if="couponOperateType == 2">
          <template #default="scope">
            <span :style="'color:' + scope.row.enabled == 2 ? 'red' : ''">{{ scope.row.enabled == 1 ? '启用' : '禁用'
              }}</span>
          </template>
        </el-table-column>
        <el-table-column property="usageAfterReceiveLimit" label="有效期" align="center">
          <template #default="scope">
            {{ limitMap.get(scope.row.usageAfterReceiveLimit) }}
          </template>
        </el-table-column>
        <el-table-column property="store" label="所属门店" width="140">
          <template #default="scope">
            <span>{{ scope.row.store.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="minQuantity" label="可用包厢" header-align="center" show-overflow-tooltip>
          <template #default="scope">
            <div v-if="scope.row.rooms.length > 0">
              <span v-for="item in scope.row.rooms" :key="item.id" style="margin-right: 10px;">{{ item.room_name
                }}</span>
            </div>
            <span v-else>暂未分配包厢</span>
          </template>
        </el-table-column>
        <el-table-column property="desc" label="规则描述" show-overflow-tooltip></el-table-column>
        <el-table-column property="sourceDesc" label="来源描述" show-overflow-tooltip></el-table-column>
        <el-table-column property="destinationDesc" label="使用描述" show-overflow-tooltip></el-table-column>
        <el-table-column property="CreatedAt" label="时间" width="100" :formatter="dateRfcHMS"
          show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="操作" width="200px;">
          <template #default="scope">
            <el-button type="text" @click="revokeCoupon(scope.row.ID)"
              v-if="couponOperateType == 1 && scope.row.status == 1">撤销卡券</el-button>
            <el-button type="text" @click="confirmGift(scope.row.ID)" v-if="couponOperateType == 2">确认赠送</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleCouponSizeChange" @current-change="handleCouponChange"
          :current-page="couponquery.page" :page-sizes="[10, 20, 50, 100, 200, 500, 9999999]"
          :page-size="couponquery.page_size" layout="total,sizes, prev, pager, next" :total="couponPageTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserList,
  setUserIsvalidate,
  getUserBalances,
  getUserIntegrals, getStoreBalances, getStoreRecord
} from "@/api/user";
import moment from "moment";
import { getStoreOption, getAreaOption } from "@/api/store";
import { getCouponUser, getVoucherList, giveUserVoucher, revocationUserVoucher } from "@/api/card_copons";
import { balancesList } from "@/constant/balances";
import { integralsList } from "@/constant/integrals";
import { ElMessageBox, ElTableColumn } from "element-plus";

export default {
  name: "UserTable",
  components: { ElTableColumn },
  data() {
    return {
      action: 'https://wx.yixiankeji.com/admin/upload',
      query: {
        nickname: "",
        real_name: '',
        phone: "",
        is_validate: null,
        page: 1,
        page_size: 10,
        sort_field: null,
        sort_asc: null,
      },
      actTitle: "添加",
      form: {}, //提交表单数据
      tableData: [],
      pageTotal: 0,
      editVisible: false,
      balances: [],
      integrals: [],
      balancesVisible: false,
      integralsVisible: false,
      storeOptions: [],
      storeMap: new Map(),
      balancesMap: new Map(),
      integralsMap: new Map(),
      integralsTotal: 0,
      balancesTotal: 0,
      integralsquery: {
        id: null,
        page: 1,
        page_size: 10
      },
      balancesquery: {
        id: null,
        page: 1,
        page_size: 10
      },
      activeName: 'local-user',
      json_user_data: [],
      json_user_fields: { //如果命名的标题有空格,需要用双引号
        客户: "nickname",
        客户手机号: "phone",
        性别: "sex",
        余额: "balance_total",
        积分: "score_total",
        累计消费: "consume_total",
        备注: "note",
        是否有效: "is_validate",
        添加时间: "at",
      },
      json_integrals_data: [],
      json_integrals_fields: {
        积分: "score",
        类型: "typeName",
        备注: "memo",
        创建时间: "at",
      },
      json_balances_data: [],
      json_balances_fields: {
        余额: "money",
        类型: "typeName",
        备注: "memo",
        "门店/平台": "store_name",
        使用门店: "use_store_name",
        创建时间: "at",
      },
      sex: [
        {
          text: '未知',
          value: 0
        },
        {
          text: '男',
          value: 1
        },
        {
          text: '女',
          value: 2
        }
      ],
      sexMap: new Map(),
      xfIcon: null,
      yeIcon: null,
      activeDName: 'first',
      storeList: [],
      activDetailName: '0',
      storeBalancesVisible: false,
      storeRecord: [],
      storequery: {
        id: null,
        page: 1,
        page_size: 10
      },
      storePageTotal: 0,
      recordquery: {
        store_id: null,
        page: 1,
        page_size: 10
      },
      recordPageTotal: 0,
      value: null,
      value2: 0,
      userName: '',
      areaOptions: [],
      area_store: [],
      props: {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      couponPageTotal: 0,
      couponquery: {
        page: 1,
        pageSize: 10,
        userId: null
      },
      CouponVisible: false,
      CouponRecord: [],
      statusMap: new Map(),
      statusInfo: [
        { value: 1, label: '未使用' },
        { value: 2, label: '已使用' },
        { value: 3, label: '未过期' }
      ],
      limitMap: new Map(),
      limitInfo: [
        { value: 99999, label: '不限时间' },
        { value: 1, label: '1天' },
        { value: 3, label: '3天' },
        { value: 7, label: '7天' },
        { value: 15, label: '15天' },
        { value: 30, label: '30天' },
        { value: 60, label: '60天' },
        { value: 90, label: '90天' }
      ],
      giftUserId: null,
      couponOperateType: 1//1-用户的卡券 2-赠送卡券
    };
  },
  created() {
    this.getData(this.value, this.value2);
    this.getStoreOption()
  },
  computed: {
    balancesList() {
      return balancesList
    },
    integralsList() {
      return integralsList
    }
  },
  methods: {
    dateRfcHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    getMap() {
      this.statusInfo.forEach(item => {
        this.statusMap.set(item.value, item.label)
      })
      this.limitInfo.forEach(item => {
        this.limitMap.set(item.value, item.label)
      })
    },
    // 触发搜索按钮
    handleSearch(value, value2) {
      this.query.sort_field = value
      if (value2 == 0) {
        this.xfIcon = null
        this.yeIcon = null
      } else if (value2 == 1) {
        this.xfIcon = !this.xfIcon
      } else if (value2 == 2) {
        this.yeIcon = !this.yeIcon
      }
      if (value == 1) {
        this.xfIcon = null
      } else if (value == 3) {
        this.yeIcon = null
      }
      this.query.sort_asc = (this.xfIcon != null) ? this.xfIcon : this.yeIcon
      this.query.page = 1
      this.getData(value, value2)
    },
    getData(value, value2) {
      this.value = value
      this.value2 = value2
      getUserList(this.query).then(res => {
        this.tableData = JSON.parse(JSON.stringify(res.data))
        this.tableData.forEach(item => {
          if (item.nickname == '') {
            item.nickname = '未知'
          }
          if (item.avatar == '') {
            item.avatar = 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
          }
        })
        this.sex.forEach(item => {
          this.sexMap.set(item.value, item.text)
        })
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData(this.value, this.value2)
    },
    setIsvalidate(index, id, isvalidate) {
      setUserIsvalidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },
    // eslint-disable-next-line no-unused-vars
    handleAvatarSuccess(res, file) {
      this.form.cover = res.url
    },
    // eslint-disable-next-line no-unused-vars
    handleListSuccess(res, file) {
      this.form.image_list.push(res.url)
    },
    // 获取余额记录
    getBalances(id, row) {
      if (row) {
        this.userName = row.real_name || (row.nickname === '未知' ? false : row.nickname) || row.phone
      }
      let that = this
      this.balancesquery.id = id
      this.storequery.id = id
      getUserBalances(id, this.balancesquery).then(res => {
        this.balances = res.data
        if (this.balancesquery.page === 1) {
          this.balancesTotal = res.count
        }
      })
      this.balancesList.forEach(function (item) {
        that.balancesMap.set(item.value, item.label)
      })
      this.activeDName = 'first'
      this.balancesVisible = true
    },
    // 获取门店余额
    getStore() {
      getStoreBalances(this.storequery.id).then(res => {
        this.storeList = res.data
        if (this.storequery.page === 1) {
          this.storePageTotal = res.count
        }
      })
    },
    // 余额详情tab点击事件
    handleBalanceClick() {
      this.getStore()
    },
    // eslint-disable-next-line no-unused-vars
    // 门店的余额记录
    showRecord(id) {
      this.balancesquery.page = 1
      this.storeBalancesVisible = true
      this.recordquery.id = id
      getStoreRecord(this.balancesquery.id, this.recordquery.id, this.recordquery).then(res => {
        this.storeRecord = res.data
        if (this.recordquery.page === 1) {
          this.recordPageTotal = res.count
        }
      })
    },
    // 获取积分记录
    getIntegrals(id, row) {
      if (row) {
        this.userName = row.real_name || (row.nickname === '未知' ? false : row.nickname) || row.phone
      }
      let that = this
      this.integralsquery.id = id
      getUserIntegrals(id, this.integralsquery).then(res => {
        this.integrals = res.data
        if (this.integralsquery.page === 1) {
          this.integralsTotal = res.count
        }
      })

      this.integralsList.forEach(function (item) {
        that.integralsMap.set(item.value, item.label)
      })
      this.integralsVisible = true
    },
    getStoreOption(id) {
      getStoreOption(id).then(res => {
        this.storeOptions = []
        res.forEach(function (val) {
          this.storeOptions.push({ label: val.label, value: parseInt(val.value) })
        }, this)
        let that = this
        this.storeOptions.forEach(function (item) {
          that.storeMap.set(item.value, item.label)
        })
      })
    },
    handleSizeChange(val) {
      this.query.page_size = val
      this.getData(this.value, this.value2)
    },
    handlebalancesSizeChange(val) {
      this.balancesquery.page_size = val
      this.getBalances(this.balancesquery.id)
    },
    handleintegralsSizeChange(val) {
      this.integralsquery.page_size = val
      this.getIntegrals(this.integralsquery.id)
    },
    // 分页导航
    handleintegralsChange(val) {
      this.integralsquery.page = val
      this.getIntegrals(this.integralsquery.id)
    },
    // 分页导航
    handlebalancesChange(val) {
      this.balancesquery.page = val
      this.getBalances(this.balancesquery.id)
    },

    handleStoreSizeChange(val) {
      this.storequery.page_size = val
      this.getStore(this.storequery.id)
    },
    handleCouponSizeChange(val) {
      this.couponquery.page_size = val
      if (this.couponOperateType == 1) {
        this.getCoupons(this.couponquery.userId)
      } else if (this.couponOperateType == 2) {
        this.giftCoupon(this.couponquery.userId)
      }

    },
    handleCouponChange(val) {
      this.couponquery.page = val
      if (this.couponOperateType == 1) {
        this.getCoupons(this.couponquery.userId)
      } else if (this.couponOperateType == 2) {
        this.giftCoupon(this.couponquery.userId)
      }
    },
    handleStoreChange(val) {
      this.storequery.page = val
      this.getBalances(this.storequery.id)
    },

    handleRecordSizeChange(val) {
      this.recordquery.page_size = val
      this.showRecord(this.recordquery.id)
    },

    handleRecordChange(val) {
      this.recordquery.page = val
      this.showRecord(this.recordquery.id)
    },

    async handleUserDownload() {
      this.json_user_data = []
      await getUserList(this.query).then(res => {
        let that = this
        res.data.forEach(item => {
          item.balance_total /= 100
          item.consume_total /= 100
          item.sex = this.sexMap.get(item.sex)
          if (item.c_at === 0) {
            item.at = "";
          } else {
            item.at = moment(parseInt(item.c_at + "000")).format("YYYY-MM-DD HH:mm:ss")
          }
          item.is_validate = item.is_validate == 1 ? '有效' : '无效'
          that.json_user_data.push(item)
        })
      })
    },

    async handleIntegralsDownload() {
      this.json_integrals_data = []
      await getUserIntegrals(this.integralsquery.id, this.integralsquery).then(res => {
        let that = this
        res.data.forEach(item => {
          item.typeName = this.integralsMap.get(item.type)
          if (item.c_at === 0) {
            item.at = "";
          } else {
            item.at = moment(parseInt(item.c_at + "000")).format("YYYY-MM-DD HH:mm:ss")
          }
          that.json_integrals_data.push(item)
        })
      })
    },
    async handleBalancesDownload() {
      this.json_balances_data = []
      await getUserBalances(this.balancesquery.id, this.balancesquery).then(res => {
        let that = this
        res.data.forEach(item => {
          item.store_name = this.storeMap.get(item.store_id)
          item.typeName = this.balancesMap.get(item.type)
          item.money /= 100
          if (item.c_at === 0) {
            item.at = "";
          } else {
            item.at = moment(parseInt(item.c_at + "000")).format("YYYY-MM-DD HH:mm:ss")
          }
          that.json_balances_data.push(item)
        })
      })
    },
    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        if (node.value != 0) {
          this.getStoreOption(node.value)
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        } else if (node.value == 0) {
          setTimeout(() => {
            nodes = [{
              value: 0,
              label: '平台通用',
              leaf: level === 1
            }];
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
    },
    visibleChange(val) {
      setTimeout(() => {
        if (!val && this.area_store != null && this.area_store.length > 1) {
          this.query.store_id = this.area_store[1]
          // this.getRoomOption(this.query.store_id)
        }
      }, 200)
    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
        this.areaOptions.unshift({ label: "全国", value: 0 })
      })
    },
    clearRoom(val) {
      if (val === null) {
        this.roomOptions = []
        this.query.room_id = null
      }
    },
    // 获取卡券列表
    getCoupons(id, row) {
      this.couponOperateType = 1
      this.getMap()
      if (row) {
        this.userName = row.real_name || (row.nickname === '未知' ? false : row.nickname) || row.phone
      }
      this.couponquery.userId = id
      getCouponUser(this.couponquery).then(res => {
        if (res.code == 0 && res.data.total > 0) {
          this.CouponRecord = res.data.list
          this.couponPageTotal = res.data.total
          this.CouponVisible = true
        } else {
          this.$message.error('暂无卡券')
          this.CouponRecord = []
        }
      })
    },
    // 赠送卡券
    giftCoupon(id) {
      this.getMap()
      this.couponOperateType = 2
      this.couponquery.userId = id
      this.giftUserId = id
      this.couponquery.enabled = 1
      let query = {
        page: this.couponquery.page,
        pageSize: this.couponquery.pageSize,
        enabled: this.couponquery.enabled,
      }
      getVoucherList(query).then(res => {
        if (res.code == 0 && res.data.total > 0) {
          this.CouponRecord = res.data.list
          this.couponPageTotal = res.data.total
          this.CouponVisible = true
        } else {
          this.$message.error('暂无卡券')
          this.CouponRecord = []
        }
      })
    },
    // 确认赠送
    confirmGift(id) {
      let that = this
      ElMessageBox.prompt('请填写赠送理由', '提示框', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputErrorMessage: '请填写赠送理由',
      })
        .then(({ value }) => {
          let data = {
            id,
            userId: that.giftUserId,
            reason: value
          }
          giveUserVoucher(JSON.stringify(data)).then(res => {
            if (res.code == 0) {
              this.$message.success('赠送成功')
              this.CouponVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.messagebox.$message({
            type: 'info',
            message: '已取消赠送',
          })
        })

    },
    // 撤销卡券
    revokeCoupon(id) {
      let that = this
      ElMessageBox.prompt('请填写撤销理由', '提示框', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputErrorMessage: '请填写撤销理由',
      })
        .then(({ value }) => {
          let data = {
            userVoucherId: id,
            userId: that.couponquery.userId,
            reason: value
          }
          revocationUserVoucher(JSON.stringify(data)).then(res => {
            if (res.code == 0) {
              that.$message.success('撤销成功')
              that.getCoupons(that.couponquery.userId)
            } else {
              that.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.messagebox.$message({
            type: 'info',
            message: '已取消撤销',
          })
        })
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-dialog__body {
  height: 50vh;
  overflow: auto;
}

/deep/.el-tabs__item {
  width: 100px;
  text-align: center;
}

.balance_detail /deep/.el-tabs__item {
  width: 250px !important;
  text-align: left;
}
</style>
